(() => {
  if (typeof window !== 'undefined' && window.__velomintVariantPickerLoaded) return;
  if (typeof window !== 'undefined') window.__velomintVariantPickerLoaded = true;

  const SIZE_TOKENS = [
    '6XL',
    '5XL',
    '4XL',
    '3XL',
    '2XL',
    'XXXL',
    'XXL',
    'XL',
    '3XS',
    '2XS',
    'XXS',
    'XS',
    'UNISZ',
    'UNICA',
    'UNICO',
    'ONE SIZE',
    'OS',
    'S',
    'M',
    'L',
  ];

  const SIZE_LABELS = {
    UNISZ: 'Única',
    UNICA: 'Única',
    UNICO: 'Única',
    'ONE SIZE': 'Única',
    OS: 'Única',
    XXXL: '3XL',
  };

  const COLOR_RULES = [
    { words: ['NEGRO', 'BLACK', 'BLK', 'NOIR', 'CORE BLACK'], label: 'Negro', color: '#151515' },
    { words: ['BLANCO', 'WHITE', 'WHT'], label: 'Blanco', color: '#f7f7f5' },
    { words: ['ROJO', 'RED', 'VELVET RED'], label: 'Rojo', color: '#d62f2f' },
    { words: ['AZUL', 'BLUE', 'BLU', 'GROUPAMA', 'MARINO', 'NAVY'], label: 'Azul', color: '#315fa8' },
    { words: ['VERDE', 'GREEN', 'GRN', 'LIME'], label: 'Verde', color: '#4f9f45' },
    { words: ['GRIS', 'GREY', 'GRAY', 'GRY'], label: 'Gris', color: '#777b80' },
    { words: ['MARRON', 'BROWN', 'BRN', 'CAFE'], label: 'Marrón', color: '#765240' },
    { words: ['AMARILLO', 'YELLOW', 'YEL'], label: 'Amarillo', color: '#f0cf27' },
    { words: ['NARANJA', 'ORANGE', 'ORA'], label: 'Naranja', color: '#ed8b21' },
    { words: ['ROSA', 'PINK', 'PNK'], label: 'Rosa', color: '#e68eb4' },
    { words: ['MORADO', 'PURPLE', 'VIOLET', 'LILA', 'PUR'], label: 'Morado', color: '#7651a8' },
    { words: ['PLATA', 'SILVER'], label: 'Plata', color: '#b9bec5' },
    { words: ['ORO', 'GOLD'], label: 'Oro', color: '#d2aa38' },
    { words: ['BEIGE', 'ARENA', 'SAND'], label: 'Beige', color: '#d8c5a7' },
    { words: ['TURQUESA', 'TURQUOISE', 'AQUA'], label: 'Turquesa', color: '#2cb8ba' },
    { words: ['TRANSPARENTE', 'TRANSPARENT', 'CLEAR'], label: 'Transparente', color: 'transparent' },
  ];

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();

  const titleCase = (value) =>
    String(value || '')
      .toLocaleLowerCase('es')
      .replace(/(^|[\s/\-])([a-záéíóúüñ])/g, (match, separator, letter) => `${separator}${letter.toUpperCase()}`);

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const sizeAtom = `(?:${SIZE_TOKENS.map(escapeRegExp).join('|')})`;
  const sizeAlternatives = `${sizeAtom}(?:[/-]${sizeAtom}){0,2}`;
  const markedSizePattern = new RegExp(
    `(^|[\\s/_-])(?:TALLA|T\\.)\\s*(${sizeAlternatives}|(?:3[4-9]|4[0-9]|50))(?=$|[\\s/_-])`,
    'i'
  );
  const plainSizePattern = new RegExp(`(^|[\\s/_-])(${sizeAlternatives})(?=$|[\\s/_-])`, 'i');

  function findColorInfo(candidate) {
    const normalized = normalize(candidate).replace(/^Q\d+\s+/, '').replace(/\s+/g, ' ').trim();
    if (!normalized) return null;

    const matchesWord = (word) => {
      if (/^[A-Z]{2,3}$/.test(word)) {
        return new RegExp(`(^|[^A-Z])${escapeRegExp(word)}(?=$|[^A-Z])`).test(normalized);
      }
      return normalized.includes(word);
    };
    const matches = COLOR_RULES.filter((rule) => rule.words.some(matchesWord));
    if (!matches.length) return null;

    const distinct = [];
    matches.forEach((match) => {
      if (!distinct.some((entry) => entry.label === match.label)) distinct.push(match);
    });

    const exactCode = normalized.match(/^(BLK|WHT|RED|BLU|GRN|GRY|BRN)(?:\/\1)?$/);
    const simpleName = COLOR_RULES.find((rule) => rule.words.includes(normalized));
    let label = titleCase(normalized.replace(/^(BLK|WHT|RED|BLU|GRN|GRY|BRN)\/\1$/, '$1'));

    if (exactCode || simpleName) label = (simpleName || distinct[0]).label;
    if (distinct.length === 1 && /^(?:Q\d+\s+)?(?:CORE |VELVET )?(?:BLACK|WHITE|RED|BLUE|GREEN|GREY|GRAY)$/i.test(normalize(candidate))) {
      label = distinct[0].label;
    }

    const background =
      distinct.length > 1
        ? `linear-gradient(135deg, ${distinct[0].color} 0 50%, ${distinct[1].color} 50% 100%)`
        : distinct[0].color;

    let exactRemainder = normalized;
    COLOR_RULES.flatMap((rule) => rule.words)
      .sort((a, b) => b.length - a.length)
      .forEach((word) => {
        exactRemainder = exactRemainder.replace(
          new RegExp(`(^|[^A-Z])${escapeRegExp(word)}(?=$|[^A-Z])`, 'g'),
          '$1'
        );
      });
    exactRemainder = exactRemainder
      .replace(/\b(?:ALTA VISIBILIDAD|HIGH VISIBILITY|VELVET|CORE|DARK|LIGHT|CLARO|OSCURO|MATE|MATT|GLOSSY|BRILLANTE|NEON|FLUO|FLUORESCENT|FDJ|METALLIC|METALIZADO)\b/g, ' ')
      .replace(/[\s/,_+\-]+/g, '');
    const exact = exactRemainder === '';
    return { label, background, known: true, exact };
  }

  function parseVariantValue(value) {
    const original = String(value || '').trim();
    const normalized = normalize(original);
    if (!normalized) return null;

    let match = normalized.match(markedSizePattern) || normalized.match(plainSizePattern);
    let size = null;
    let remainder = normalized;

    if (match) {
      const rawSize = normalize(match[2]);
      size = SIZE_LABELS[rawSize] || rawSize;
      remainder = `${normalized.slice(0, match.index)} ${normalized.slice(match.index + match[0].length)}`;
      remainder = remainder.replace(/^[\s/_-]+|[\s/_-]+$/g, '').replace(/\s+/g, ' ').trim();
    }

    const color = findColorInfo(remainder);
    if (!size && !color) return null;

    return {
      original,
      size,
      sizeKey: size ? normalize(size) : null,
      color: color?.label || null,
      colorKey: color ? normalize(remainder) : null,
      colorBackground: color?.background || null,
      colorKnown: Boolean(color),
      colorExact: Boolean(color?.exact),
      remainder,
    };
  }

  function inferVariantModel(inputs) {
    const items = inputs.map((input) => ({
      input,
      available: !input.classList.contains('disabled') && !input.disabled,
      parsed: parseVariantValue(input.value),
    }));

    if (!items.length || items.some((item) => !item.parsed)) return { type: 'fallback', items };

    const everySize = items.every((item) => item.parsed.size);
    const everyColor = items.every((item) => item.parsed.color);
    const everyColorExact = items.every((item) => item.parsed.colorExact);
    const everyPureSize = items.every((item) => item.parsed.size && !item.parsed.remainder);
    const sizes = new Set(items.map((item) => item.parsed.sizeKey).filter(Boolean));
    const colors = new Set(items.map((item) => item.parsed.colorKey).filter(Boolean));

    if (everySize && everyColor && everyColorExact && sizes.size > 0 && colors.size > 0) {
      const pairs = new Set(items.map((item) => `${item.parsed.colorKey}::${item.parsed.sizeKey}`));
      if (pairs.size === items.length) return { type: 'color-size', items };
    }

    if (everyColor && everyColorExact && colors.size > 0 && !items.some((item) => item.parsed.size)) {
      return { type: 'color', items };
    }

    if (everyPureSize && sizes.size > 0) {
      const uniqueSizes = new Set(items.map((item) => item.parsed.sizeKey));
      if (uniqueSizes.size === items.length) return { type: 'size', items };
    }

    return { type: 'fallback', items };
  }

  function createChoice({ kind, key, label, background, known = true, onSelect }) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `velomint-choice velomint-choice--${kind}`;
    button.dataset.key = key;
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-disabled', 'false');

    if (kind === 'color') {
      const swatch = document.createElement('span');
      swatch.className = `velomint-choice__swatch${known ? '' : ' velomint-choice__swatch--unknown'}`;
      if (background) swatch.style.setProperty('--velomint-swatch-background', background);
      swatch.setAttribute('aria-hidden', 'true');
      button.append(swatch);
    }

    const text = document.createElement('span');
    text.className = 'velomint-choice__text';
    text.textContent = label;
    button.append(text);

    button.addEventListener('click', () => {
      if (button.getAttribute('aria-disabled') === 'true') return;
      onSelect(key);
    });

    return button;
  }

  function buildGroup(kind, choices, onSelect) {
    const fieldset = document.createElement('fieldset');
    fieldset.className = `velomint-choice-group velomint-choice-group--${kind}`;

    const legend = document.createElement('legend');
    legend.className = 'velomint-choice-group__legend';
    legend.append(`${kind === 'color' ? 'Color' : 'Talla'}:`);

    const current = document.createElement('span');
    current.className = 'velomint-choice-group__current';
    current.dataset.current = kind;
    legend.append(current);
    fieldset.append(legend);

    const options = document.createElement('div');
    options.className = 'velomint-choice-options';
    options.dataset.options = kind;

    choices.forEach((choice) => options.append(createChoice({ kind, ...choice, onSelect })));
    fieldset.append(options);
    return fieldset;
  }

  function enhanceCombinedFieldset(fieldset) {
    const inputs = Array.from(fieldset.querySelectorAll("input[type='radio']"));
    if (!inputs.length) {
      fieldset.classList.add('velomint-variant-fallback');
      return;
    }

    const model = inferVariantModel(inputs);
    if (model.type === 'fallback') {
      fieldset.classList.add('velomint-variant-fallback');
      const legend = fieldset.querySelector('legend');
      if (legend && model.items.some((item) => item.parsed?.size || item.parsed?.color)) legend.textContent = 'Color / Talla';
      return;
    }

    const picker = document.createElement('div');
    picker.className = 'velomint-choice-picker';
    picker.dataset.model = model.type;

    const uniqueChoices = (kind) => {
      const map = new Map();
      model.items.forEach((item) => {
        const parsed = item.parsed;
        const key = kind === 'color' ? parsed.colorKey : parsed.sizeKey;
        if (!key || map.has(key)) return;
        map.set(key, {
          key,
          label: kind === 'color' ? parsed.color : parsed.size,
          background: parsed.colorBackground,
          known: parsed.colorKnown,
        });
      });
      return Array.from(map.values());
    };

    const selectedItem = () => model.items.find((item) => item.input.checked) || model.items[0];

    const selectItem = (item) => {
      if (!item) return;
      item.input.checked = true;
      update();
      item.input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const selectColor = (colorKey) => {
      const current = selectedItem();
      const candidates = model.items.filter((item) => item.parsed.colorKey === colorKey);
      const sameSize = candidates.filter((item) => item.parsed.sizeKey === current.parsed.sizeKey);
      selectItem(sameSize.find((item) => item.available) || candidates.find((item) => item.available) || sameSize[0] || candidates[0]);
    };

    const selectSize = (sizeKey) => {
      const current = selectedItem();
      const candidates = model.items.filter((item) => item.parsed.sizeKey === sizeKey);
      const sameColor = candidates.filter((item) => item.parsed.colorKey === current.parsed.colorKey);
      selectItem(sameColor.find((item) => item.available) || candidates.find((item) => item.available) || sameColor[0] || candidates[0]);
    };

    if (model.type.includes('color')) picker.append(buildGroup('color', uniqueChoices('color'), selectColor));
    if (model.type.includes('size')) picker.append(buildGroup('size', uniqueChoices('size'), selectSize));

    const update = () => {
      const current = selectedItem();
      ['color', 'size'].forEach((kind) => {
        const key = kind === 'color' ? current.parsed.colorKey : current.parsed.sizeKey;
        const label = kind === 'color' ? current.parsed.color : current.parsed.size;
        const currentLabel = picker.querySelector(`[data-current='${kind}']`);
        if (currentLabel) currentLabel.textContent = label || '';

        picker.querySelectorAll(`[data-options='${kind}'] .velomint-choice`).forEach((button) => {
          const buttonKey = button.dataset.key;
          button.setAttribute('aria-pressed', String(buttonKey === key));

          let candidates = model.items.filter((item) => item.parsed[`${kind}Key`] === buttonKey);
          if (model.type === 'color-size' && kind === 'size') {
            candidates = candidates.filter((item) => item.parsed.colorKey === current.parsed.colorKey);
          }
          button.setAttribute('aria-disabled', String(!candidates.some((item) => item.available)));
        });
      });
    };

    fieldset.before(picker);
    fieldset.classList.add('velomint-original-picker--hidden');
    fieldset.setAttribute('aria-hidden', 'true');
    update();
  }

  function styleNativeGroup(fieldset, kind) {
    fieldset.classList.add(kind === 'color' ? 'velomint-native-color' : 'velomint-native-size');
    if (kind !== 'color') return;

    fieldset.querySelectorAll("input[type='radio']").forEach((input) => {
      const label = Array.from(fieldset.querySelectorAll('label')).find((candidate) => candidate.htmlFor === input.id);
      if (!label || label.querySelector('.velomint-native-color__swatch')) return;
      const info = findColorInfo(input.value);
      const swatch = document.createElement('span');
      swatch.className = 'velomint-native-color__swatch';
      if (info?.background) swatch.style.setProperty('--velomint-swatch-background', info.background);
      swatch.setAttribute('aria-hidden', 'true');
      label.prepend(swatch);
    });
  }

  function enhanceVariantSelects(selects) {
    if (selects.dataset.velomintEnhanced === 'true') return;
    selects.dataset.velomintEnhanced = 'true';

    const fieldsets = Array.from(selects.querySelectorAll('fieldset.product-form__input--pill'));
    fieldsets.forEach((fieldset) => {
      const firstInput = fieldset.querySelector("input[type='radio']");
      const optionName = normalize(firstInput?.dataset.optionName || fieldset.querySelector('legend')?.textContent);

      if (/COLOR|COLOUR/.test(optionName)) styleNativeGroup(fieldset, 'color');
      else if (/TALLA|SIZE|TAMANO/.test(optionName)) styleNativeGroup(fieldset, 'size');
      else if (/VARIANTE|VARIANT/.test(optionName)) enhanceCombinedFieldset(fieldset);
      else fieldset.classList.add('velomint-variant-fallback');
    });
  }

  function enhanceAll(root = document) {
    root.querySelectorAll('variant-selects[data-velomint-smart-variants]').forEach(enhanceVariantSelects);
  }

  const api = { normalize, findColorInfo, parseVariantValue, inferVariantModel };
  if (typeof window !== 'undefined') window.VelomintVariantPicker = api;
  if (typeof document === 'undefined') return;

  const start = () => {
    enhanceAll();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) =>
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches?.('variant-selects[data-velomint-smart-variants]')) enhanceVariantSelects(node);
          else enhanceAll(node);
        })
      );
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
